import { PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './bordered-container.style';

const BorderedContainer = ({ children }: PropsWithChildren) => {
  const styles = componentStyles();

  return <Box style={styles.wrapper}>{children}</Box>;
};

export default BorderedContainer;
